import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=6d3044e8&scoped=true"
import script from "./input-file.vue?vue&type=script&lang=js"
export * from "./input-file.vue?vue&type=script&lang=js"
import style0 from "./input-file.vue?vue&type=style&index=0&id=6d3044e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3044e8",
  null
  
)

export default component.exports